import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() buttonType: BUTTON_TYPE = BUTTON_TYPE.FULL;
  @Input() text = 'Empty';
  @Input() buttonSize = BUTTON_SIZE.NORMAL;
  @Input() lightBackground = false;
  @Input() disabled = false;

  constructor() {
  }

  ngOnInit() {
  }

}

enum BUTTON_TYPE {
  FULL = 'FULL',
  EMPTY = 'EMPTY',
  OUTLINE = 'OUTLINE',
  BLOCK = 'BLOCK'
}

enum BUTTON_SIZE {
  NORMAL = 'NORMAL',
  SMALL = 'SMALL'
}
